var Ne = Object.defineProperty, ze = Object.defineProperties;
var $e = Object.getOwnPropertyDescriptors;
var X = Object.getOwnPropertySymbols;
var me = Object.prototype.hasOwnProperty, ve = Object.prototype.propertyIsEnumerable;
var ue = (t, e, s) => e in t ? Ne(t, e, { enumerable: !0, configurable: !0, writable: !0, value: s }) : t[e] = s, r = (t, e) => {
  for (var s in e || (e = {}))
    me.call(e, s) && ue(t, s, e[s]);
  if (X)
    for (var s of X(e))
      ve.call(e, s) && ue(t, s, e[s]);
  return t;
}, h = (t, e) => ze(t, $e(e));
var w = (t, e) => {
  var s = {};
  for (var o in t)
    me.call(t, o) && e.indexOf(o) < 0 && (s[o] = t[o]);
  if (t != null && X)
    for (var o of X(t))
      e.indexOf(o) < 0 && ve.call(t, o) && (s[o] = t[o]);
  return s;
};
import { jsx as g, jsxs as Se } from "react/jsx-runtime";
import { r as F } from "./rem-CMQJ_ZTp.js";
import { Fragment as Be, createElement as Ee } from "react";
import { a as P, c as fe, e as we } from "./get-size-Bc1Pz5yf.js";
import { c as G } from "./create-vars-resolver-Bzbn9G-G.js";
import { f as L, u as $, B as q, e as We } from "./factory-ueRxoNOV.js";
import { u as T } from "./use-styles-DToiHEa6.js";
import { p as Ce } from "./polymorphic-factory-DufevJAl.js";
import { c as Ie } from "./create-optional-context-CQ2ahjKQ.js";
import { u as Re } from "./use-resolved-styles-api-D-aL_8KF.js";
import { C as Pe } from "./CloseButton-BysQSF2E.js";
import { u as qe } from "./use-id-D2tGiO9x.js";
const [Ae, De] = Ie({
  size: "sm"
}), Fe = {}, be = L((t, e) => {
  const s = $("InputClearButton", Fe, t), I = s, { size: o, variant: a, vars: c, classNames: v, styles: _ } = I, f = w(I, ["size", "variant", "vars", "classNames", "styles"]), d = De(), { resolvedClassNames: S, resolvedStyles: p } = Re({
    classNames: v,
    styles: _,
    props: s
  });
  return /* @__PURE__ */ g(
    Pe,
    r({
      variant: a || "transparent",
      ref: e,
      size: o || (d == null ? void 0 : d.size) || "sm",
      classNames: S,
      styles: p,
      __staticSelector: "InputClearButton"
    }, f)
  );
});
be.displayName = "@mantine/core/InputClearButton";
const [Le, Y] = Ie({
  offsetBottom: !1,
  offsetTop: !1,
  describedBy: void 0,
  getStyles: null,
  inputId: void 0,
  labelId: void 0
});
var z = { wrapper: "m_6c018570", input: "m_8fb7ebe7", section: "m_82577fc2", placeholder: "m_88bacfd0", root: "m_46b77525", label: "m_8fdc1311", required: "m_78a94662", error: "m_8f816625", description: "m_fe47ce59" };
const ye = {}, Te = G((t, { size: e }) => ({
  description: {
    "--input-description-size": e === void 0 ? void 0 : `calc(${P(e)} - ${F(2)})`
  }
})), Z = L((t, e) => {
  const s = $("InputDescription", ye, t), N = $("InputDescription", ye, s), {
    classNames: o,
    className: a,
    style: c,
    styles: v,
    unstyled: _,
    vars: f,
    size: d,
    __staticSelector: S,
    __inheritStyles: p = !0,
    variant: I
  } = N, u = w(N, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "size",
    "__staticSelector",
    "__inheritStyles",
    "variant"
  ]), l = Y(), n = T({
    name: ["InputWrapper", S],
    props: s,
    classes: z,
    className: a,
    style: c,
    classNames: o,
    styles: v,
    unstyled: _,
    rootSelector: "description",
    vars: f,
    varsResolver: Te
  }), m = p && (l == null ? void 0 : l.getStyles) || n;
  return /* @__PURE__ */ g(
    q,
    r(r({
      component: "p",
      ref: e,
      variant: I,
      size: d
    }, m("description", l != null && l.getStyles ? { className: a, style: c } : void 0)), u)
  );
});
Z.classes = z;
Z.displayName = "@mantine/core/InputDescription";
const ke = {}, je = G((t, { size: e }) => ({
  error: {
    "--input-error-size": e === void 0 ? void 0 : `calc(${P(e)} - ${F(2)})`
  }
})), x = L((t, e) => {
  const s = $("InputError", ke, t), N = s, {
    classNames: o,
    className: a,
    style: c,
    styles: v,
    unstyled: _,
    vars: f,
    size: d,
    __staticSelector: S,
    __inheritStyles: p = !0,
    variant: I
  } = N, u = w(N, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "size",
    "__staticSelector",
    "__inheritStyles",
    "variant"
  ]), l = T({
    name: ["InputWrapper", S],
    props: s,
    classes: z,
    className: a,
    style: c,
    classNames: o,
    styles: v,
    unstyled: _,
    rootSelector: "error",
    vars: f,
    varsResolver: je
  }), n = Y(), m = p && (n == null ? void 0 : n.getStyles) || l;
  return /* @__PURE__ */ g(
    q,
    r(r({
      component: "p",
      ref: e,
      variant: I,
      size: d
    }, m("error", n != null && n.getStyles ? { className: a, style: c } : void 0)), u)
  );
});
x.classes = z;
x.displayName = "@mantine/core/InputError";
const he = {
  labelElement: "label"
}, Oe = G((t, { size: e }) => ({
  label: {
    "--input-label-size": P(e),
    "--input-asterisk-color": void 0
  }
})), ee = L((t, e) => {
  const s = $("InputLabel", he, t), A = $("InputLabel", he, s), {
    classNames: o,
    className: a,
    style: c,
    styles: v,
    unstyled: _,
    vars: f,
    labelElement: d,
    size: S,
    required: p,
    htmlFor: I,
    onMouseDown: u,
    children: l,
    __staticSelector: n,
    variant: m,
    mod: N
  } = A, b = w(A, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "labelElement",
    "size",
    "required",
    "htmlFor",
    "onMouseDown",
    "children",
    "__staticSelector",
    "variant",
    "mod"
  ]), i = T({
    name: ["InputWrapper", n],
    props: s,
    classes: z,
    className: a,
    style: c,
    classNames: o,
    styles: v,
    unstyled: _,
    rootSelector: "label",
    vars: f,
    varsResolver: Oe
  }), B = Y(), k = (B == null ? void 0 : B.getStyles) || i;
  return /* @__PURE__ */ Se(
    q,
    h(r(h(r({}, k("label", B != null && B.getStyles ? { className: a, style: c } : void 0)), {
      component: d,
      variant: m,
      size: S,
      ref: e,
      htmlFor: d === "label" ? I : void 0,
      mod: [{ required: p }, N],
      onMouseDown: (E) => {
        u == null || u(E), !E.defaultPrevented && E.detail > 1 && E.preventDefault();
      }
    }), b), {
      children: [
        l,
        p && /* @__PURE__ */ g("span", h(r({}, k("required")), { "aria-hidden": !0, children: " *" }))
      ]
    })
  );
});
ee.classes = z;
ee.displayName = "@mantine/core/InputLabel";
const _e = {}, le = L((t, e) => {
  const s = $("InputPlaceholder", _e, t), n = $("InputPlaceholder", _e, s), {
    classNames: o,
    className: a,
    style: c,
    styles: v,
    unstyled: _,
    vars: f,
    __staticSelector: d,
    variant: S,
    error: p,
    mod: I
  } = n, u = w(n, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "__staticSelector",
    "variant",
    "error",
    "mod"
  ]), l = T({
    name: ["InputPlaceholder", d],
    props: s,
    classes: z,
    className: a,
    style: c,
    classNames: o,
    styles: v,
    unstyled: _,
    rootSelector: "placeholder"
  });
  return /* @__PURE__ */ g(
    q,
    r(h(r({}, l("placeholder")), {
      mod: [{ error: !!p }, I],
      component: "span",
      variant: S,
      ref: e
    }), u)
  );
});
le.classes = z;
le.displayName = "@mantine/core/InputPlaceholder";
function Ve(t, { hasDescription: e, hasError: s }) {
  const o = t.findIndex((f) => f === "input"), a = t.slice(0, o), c = t.slice(o + 1), v = e && a.includes("description") || s && a.includes("error");
  return { offsetBottom: e && c.includes("description") || s && c.includes("error"), offsetTop: v };
}
const Ge = {
  labelElement: "label",
  inputContainer: (t) => t,
  inputWrapperOrder: ["label", "description", "input", "error"]
}, He = G((t, { size: e }) => ({
  label: {
    "--input-label-size": P(e),
    "--input-asterisk-color": void 0
  },
  error: {
    "--input-error-size": e === void 0 ? void 0 : `calc(${P(e)} - ${F(2)})`
  },
  description: {
    "--input-description-size": e === void 0 ? void 0 : `calc(${P(e)} - ${F(2)})`
  }
})), ce = L((t, e) => {
  const s = $("InputWrapper", Ge, t), pe = s, {
    classNames: o,
    className: a,
    style: c,
    styles: v,
    unstyled: _,
    vars: f,
    size: d,
    variant: S,
    __staticSelector: p,
    inputContainer: I,
    inputWrapperOrder: u,
    label: l,
    error: n,
    description: m,
    labelProps: N,
    descriptionProps: b,
    errorProps: i,
    labelElement: B,
    children: k,
    withAsterisk: A,
    id: E,
    required: te,
    __stylesApiProps: se,
    mod: re
  } = pe, de = w(pe, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "size",
    "variant",
    "__staticSelector",
    "inputContainer",
    "inputWrapperOrder",
    "label",
    "error",
    "description",
    "labelProps",
    "descriptionProps",
    "errorProps",
    "labelElement",
    "children",
    "withAsterisk",
    "id",
    "required",
    "__stylesApiProps",
    "mod"
  ]), H = T({
    name: ["InputWrapper", p],
    props: se || s,
    classes: z,
    className: a,
    style: c,
    classNames: o,
    styles: v,
    unstyled: _,
    vars: f,
    varsResolver: He
  }), C = {
    size: d,
    variant: S,
    __staticSelector: p
  }, R = qe(E), oe = typeof A == "boolean" ? A : te, J = (i == null ? void 0 : i.id) || `${R}-error`, K = (b == null ? void 0 : b.id) || `${R}-description`, M = R, j = !!n && typeof n != "boolean", O = !!m, Q = `${j ? J : ""} ${O ? K : ""}`, ne = Q.trim().length > 0 ? Q.trim() : void 0, y = (N == null ? void 0 : N.id) || `${R}-label`, ie = l && /* @__PURE__ */ g(
    ee,
    h(r(r({
      labelElement: B,
      id: y,
      htmlFor: M,
      required: oe
    }, C), N), {
      children: l
    }),
    "label"
  ), D = O && /* @__PURE__ */ g(
    Z,
    h(r(r({}, b), C), {
      size: (b == null ? void 0 : b.size) || C.size,
      id: (b == null ? void 0 : b.id) || K,
      children: m
    }),
    "description"
  ), ae = /* @__PURE__ */ g(Be, { children: I(k) }, "input"), V = j && /* @__PURE__ */ Ee(
    x,
    h(r(r({}, i), C), {
      size: (i == null ? void 0 : i.size) || C.size,
      key: "error",
      id: (i == null ? void 0 : i.id) || J
    }),
    n
  ), U = u.map((ge) => {
    switch (ge) {
      case "label":
        return ie;
      case "input":
        return ae;
      case "description":
        return D;
      case "error":
        return V;
      default:
        return null;
    }
  });
  return /* @__PURE__ */ g(
    Le,
    {
      value: r({
        getStyles: H,
        describedBy: ne,
        inputId: M,
        labelId: y
      }, Ve(u, { hasDescription: O, hasError: j })),
      children: /* @__PURE__ */ g(
        q,
        h(r(r({
          ref: e,
          variant: S,
          size: d,
          mod: [{ error: !!n }, re]
        }, H("root")), de), {
          children: U
        })
      )
    }
  );
});
ce.classes = z;
ce.displayName = "@mantine/core/InputWrapper";
const Je = {
  variant: "default",
  leftSectionPointerEvents: "none",
  rightSectionPointerEvents: "none",
  withAria: !0,
  withErrorStyles: !0
}, Ke = G((t, e, s) => ({
  wrapper: {
    "--input-margin-top": s.offsetTop ? "calc(var(--mantine-spacing-xs) / 2)" : void 0,
    "--input-margin-bottom": s.offsetBottom ? "calc(var(--mantine-spacing-xs) / 2)" : void 0,
    "--input-height": fe(e.size, "input-height"),
    "--input-fz": P(e.size),
    "--input-radius": e.radius === void 0 ? void 0 : we(e.radius),
    "--input-left-section-width": e.leftSectionWidth !== void 0 ? F(e.leftSectionWidth) : void 0,
    "--input-right-section-width": e.rightSectionWidth !== void 0 ? F(e.rightSectionWidth) : void 0,
    "--input-padding-y": e.multiline ? fe(e.size, "input-padding-y") : void 0,
    "--input-left-section-pointer-events": e.leftSectionPointerEvents,
    "--input-right-section-pointer-events": e.rightSectionPointerEvents
  }
})), W = Ce((t, e) => {
  const s = $("Input", Je, t), U = s, {
    classNames: o,
    className: a,
    style: c,
    styles: v,
    unstyled: _,
    required: f,
    __staticSelector: d,
    __stylesApiProps: S,
    size: p,
    wrapperProps: I,
    error: u,
    disabled: l,
    leftSection: n,
    leftSectionProps: m,
    leftSectionWidth: N,
    rightSection: b,
    rightSectionProps: i,
    rightSectionWidth: B,
    rightSectionPointerEvents: k,
    leftSectionPointerEvents: A,
    variant: E,
    vars: te,
    pointer: se,
    multiline: re,
    radius: de,
    id: H,
    withAria: C,
    withErrorStyles: R,
    mod: oe,
    inputSize: J,
    __clearSection: K,
    __clearable: M,
    __defaultRightSection: j
  } = U, O = w(U, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "required",
    "__staticSelector",
    "__stylesApiProps",
    "size",
    "wrapperProps",
    "error",
    "disabled",
    "leftSection",
    "leftSectionProps",
    "leftSectionWidth",
    "rightSection",
    "rightSectionProps",
    "rightSectionWidth",
    "rightSectionPointerEvents",
    "leftSectionPointerEvents",
    "variant",
    "vars",
    "pointer",
    "multiline",
    "radius",
    "id",
    "withAria",
    "withErrorStyles",
    "mod",
    "inputSize",
    "__clearSection",
    "__clearable",
    "__defaultRightSection"
  ]), { styleProps: Q, rest: ne } = We(O), y = Y(), ie = { offsetBottom: y == null ? void 0 : y.offsetBottom, offsetTop: y == null ? void 0 : y.offsetTop }, D = T({
    name: ["Input", d],
    props: S || s,
    classes: z,
    className: a,
    style: c,
    classNames: o,
    styles: v,
    unstyled: _,
    stylesCtx: ie,
    rootSelector: "wrapper",
    vars: te,
    varsResolver: Ke
  }), ae = C ? {
    required: f,
    disabled: l,
    "aria-invalid": !!u,
    "aria-describedby": y == null ? void 0 : y.describedBy,
    id: (y == null ? void 0 : y.inputId) || H
  } : {}, V = b || M && K || j;
  return /* @__PURE__ */ g(Ae, { value: { size: p || "sm" }, children: /* @__PURE__ */ Se(
    q,
    h(r(r(r({}, D("wrapper")), Q), I), {
      mod: [
        {
          error: !!u && R,
          pointer: se,
          disabled: l,
          multiline: re,
          "data-with-right-section": !!V,
          "data-with-left-section": !!n
        },
        oe
      ],
      variant: E,
      size: p,
      children: [
        n && /* @__PURE__ */ g(
          "div",
          h(r(h(r({}, m), {
            "data-position": "left"
          }), D("section", {
            className: m == null ? void 0 : m.className,
            style: m == null ? void 0 : m.style
          })), {
            children: n
          })
        ),
        /* @__PURE__ */ g(
          q,
          r(h(r(r({
            component: "input"
          }, ne), ae), {
            ref: e,
            required: f,
            mod: { disabled: l, error: !!u && R },
            variant: E,
            __size: J
          }), D("input"))
        ),
        V && /* @__PURE__ */ g(
          "div",
          h(r(h(r({}, i), {
            "data-position": "right"
          }), D("section", {
            className: i == null ? void 0 : i.className,
            style: i == null ? void 0 : i.style
          })), {
            children: V
          })
        )
      ]
    })
  ) });
});
W.classes = z;
W.Wrapper = ce;
W.Label = ee;
W.Error = x;
W.Description = Z;
W.Placeholder = le;
W.ClearButton = be;
W.displayName = "@mantine/core/Input";
export {
  W as I,
  Y as u
};
